import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import DaProtectNotice from '../DaProtectNotice';
import BetaBadge from '@wix/da-ds/pkg/BetaBadge';

import s from './HoverComponent.scss';

interface Props {
  imageFileName: string;
  imageMarginBottom?: number;
  imageMarginLeft?: number;
  title: string;
  context: string;
  isNew?: boolean;
  showDaProtect?: boolean;
  className?: string;
}

const HoverComponent: React.FC<Props> = ({
  imageFileName,
  imageMarginBottom,
  imageMarginLeft,
  title,
  context,
  className,
  isNew = false,
  showDaProtect = false,
}) => {
  return (
    <div className={classnames('ds-surface-tertiary', s['root'], className)}>
      <div
        className={classnames(
          s['container'],
          showDaProtect && s['da-protect-container'],
          isNew && s['new-container']
        )}
      >
        <img
          className={s['image']}
          loading="lazy"
          src={Url.staticCDNLink(`eclipse/popups/hover-component/2024/${imageFileName}`)}
          alt=""
          style={{
            marginBottom: imageMarginBottom,
            marginLeft: imageMarginLeft,
          }}
        />
        {isNew && <BetaBadge badgeType="new" size="medium" variant="green" />}
        <div className={s['title']}>{title}</div>
        <div className={s['context']}>{context}</div>
        {showDaProtect && <DaProtectNotice />}
      </div>
    </div>
  );
};

HoverComponent.displayName = 'HoverComponent';
export default HoverComponent;
